(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSMovimientoEstatusProyectoDetailController', SSMovimientoEstatusProyectoDetailController);

    SSMovimientoEstatusProyectoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SSMovimientoEstatusProyecto', 'SSProyecto'];

    function SSMovimientoEstatusProyectoDetailController($scope, $rootScope, $stateParams, previousState, entity, SSMovimientoEstatusProyecto, SSProyecto) {
        var vm = this;

        vm.sSMovimientoEstatusProyecto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('serviciosocialApp:sSMovimientoEstatusProyectoUpdate', function(event, result) {
            vm.sSMovimientoEstatusProyecto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
